// pages/CouleurMarque/marques/Marques.jsx
import React from 'react'
import { Card, Space, Tag, Progress, Tooltip } from 'antd'
import { 
    ShopOutlined, 
    ShoppingCartOutlined, 
    DollarOutlined 
} from '@ant-design/icons';

const Marques = ({ data = [], loading = false }) => {
    const maxVentes = data.length > 0 ? Math.max(...data.map(item => item.quantite_vendue || 0)) : 0;

    return (
        <Card className="marques" loading={loading}>
            <div className="marque_header">
                <Space>
                    <ShopOutlined style={{ fontSize: 18, color: '#1a1a1a' }} />
                    <h3>Matières</h3>
                </Space>
                <Tag color="default">Matières / marges</Tag>
            </div>

            <div className="marque_list">
                {data.length === 0 ? (
                    <div className="empty-state">
                        <p>Aucune donnée disponible</p>
                    </div>
                ) : (
                    data.map((item, index) => {
                        const percent = maxVentes > 0 ? (item.quantite_vendue / maxVentes) * 100 : 0;
                        const margePercent = item.marge_pourcentage || 0;
                        
                        return (
                            <div key={index} className="marque_item">
                                <div className="marque_info">
                                    <div className="marque_name_wrapper">
                                        <span className="marque_name">{item.matiere}</span>
                                        <Tag 
                                            size="small" 
                                            color={margePercent > 40 ? 'success' : margePercent > 20 ? 'warning' : 'error'}
                                            className="marque_tag"
                                        >
                                            Marge {margePercent}%
                                        </Tag>
                                        <Tag 
                                            size="small" 
                                            color={item.recommandation?.includes('⭐') ? 'success' : item.recommandation?.includes('⚠️') ? 'error' : 'default'}
                                            className="marque_tag"
                                        >
                                            {item.recommandation?.includes('⭐') ? '⭐ Premium' : item.recommandation?.includes('⚠️') ? '⚠️ Prudence' : 'Standard'}
                                        </Tag>
                                    </div>
                                    <div className="marque_stats">
                                        <Tooltip title="Quantité vendue">
                                            <span className="stat">
                                                <ShoppingCartOutlined /> {item.quantite_vendue || 0}
                                            </span>
                                        </Tooltip>
                                        <Tooltip title="Prix moyen">
                                            <span className="stat">
                                                <DollarOutlined /> {Number(item.prix_moyen || 0).toLocaleString()} $
                                            </span>
                                        </Tooltip>
                                    </div>
                                </div>
                                <Progress 
                                    percent={Math.round(percent)} 
                                    size="small" 
                                    status={percent > 50 ? "active" : "normal"}
                                    strokeColor={margePercent > 40 ? '#52c41a' : margePercent > 20 ? '#faad14' : '#ff4d4f'}
                                    showInfo={false}
                                />
                            </div>
                        );
                    })
                )}
            </div>
        </Card>
    )
}

export default Marques